


import React, { useState } from 'react';
import { Avatar, Box, Button, Card, CardActionArea, CardContent, CardHeader, CardMedia, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography, useTheme } from '@mui/material';
import { ArrowRightAltOutlined, ArrowRightOutlined, AssistantDirectionRounded, AssistantPhotoOutlined, CheckCircleOutlineRounded, Circle, InfoOutlined, QuizOutlined, SavedSearch } from "@mui/icons-material";
import { alpha } from "@mui/material/styles";

const VideoSection = ({ payload }) => {
    
  return (
    <>
        {payload && 
            payload.map((item, idx) => {
                return (
                    <Card
                        sx={{
                        mt: 10,  border: 1,
                        borderColor: 'primary.main',
                        background: "#0A192F",
                        background: "linear-gradient(90deg,rgba(10, 25, 47, 1) 0%, rgba(23, 42, 69, 1) 11%, rgba(23, 42, 69, 1) 45%, rgba(2, 12, 27, 1) 100%)",
                        }}
                        
                    >
                        <CardHeader
                                avatar={
                                <Avatar
                                    sx={(theme) => ({
                                    bgcolor:
                                        theme.palette.mode === "dark"
                                        ? alpha(theme.palette.secondary.main, 0.25)
                                        : alpha(theme.palette.secondary.main, 0.12),
                                    color: theme.palette.secondary.main,
                                    })}
                                    variant="rounded"
                                >
                                    {(idx % 2) == 0 ? <AssistantPhotoOutlined /> : <SavedSearch />}
                                </Avatar>
                                }
                                title={
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography variant="h5" sx={{ fontWeight: 700, color: 'white' }}>
                                        {item.title}
                                    </Typography>
                                </Box>
                                }
                                subheader={
                                <Box>
                                    <Typography component={'body1'} sx={{color: 'white'}}>
                                        {item.header}
                                    </Typography>
                                </Box>
                                
                            }
                            />
                        <CardActionArea>
                            <CardMedia
                                component="video"
                                height="auto"
                                width="100%"
                                src='video'
                                image={item.link}
                                autoPlay
                                muted
                                loop
                            />
                            <CardContent>
                                {item.features.map((text) => (
                                    <Box sx={{display: 'flex', alignContent: 'center', alignItems: 'center'}}>
                                    <ArrowRightOutlined color='secondary' />
                                    <Typography variant='body1' sx={{color: 'white', fontWeight: 600}}>
                                        {text}
                                    </Typography>
                                    </Box>
                                ))}
                            </CardContent>
                        </CardActionArea>
                    </Card>
                )
            })
        }
    </>
  );
};

export default VideoSection;
